import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
import { sendTemplateMessage } from 'modules/accommodations/features/reservations/api';

export const useCalculationMessageTemplateMutation = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate: sendMessageTask, isLoading: isSending } = useMutation(sendTemplateMessage, {
    onSuccess: () => successToast(t('Message sent successfully.')),
    onError: (res: any) => errorToast(res?.response?.data?.ErrorDescription),
  });

  return {
    isSending,
    sendMessageTask,
  };
};
